import React from 'react';
const testimonials = [{
  initials: 'VT',
  quote: 'Tuve cándida 5 veces en un año. Después del protocolo, llevo 4 meses sin una sola recaída.',
  name: 'Valentina',
  city: 'CABA'
}, {
  initials: 'RO',
  quote: 'Lo mío era intestinal. Nadie me lo había relacionado con la cándida. Perdí 3 kilos de inflamación en 10 días.',
  name: 'Romina',
  city: 'Rosario'
}, {
  initials: 'LC',
  quote: 'Mi relación de pareja estaba sufriendo. Hoy eso es historia.',
  name: 'Lucía',
  city: 'Córdoba'
}];
export function MiniTestimonials() {
  return <section className="w-full bg-[#F8F5FC] py-8 overflow-hidden" data-id="element-161">
      <div className="w-full overflow-x-auto hide-scrollbar px-4 pb-4" data-id="element-162">
        <div className="flex gap-4 min-w-max mx-auto md:justify-center" data-id="element-163">
          {testimonials.map((t, i) => <div key={i} className="w-[280px] bg-white rounded-[16px] p-5 shadow-[0_4px_24px_rgba(0,0,0,0.08)] border border-brand-gray flex flex-col" data-id="element-164">
              <div className="flex items-center gap-3 mb-3" data-id="element-165">
                <div className="w-10 h-10 rounded-full bg-brand-violet/10 text-brand-violet flex items-center justify-center font-bold text-sm" data-id="element-166">
                  {t.initials}
                </div>
                <div className="flex flex-col" data-id="element-167">
                  <span className="text-brand-text font-bold text-[14px] leading-tight" data-id="element-168">
                    {t.name}
                  </span>
                  <span className="text-brand-muted text-[12px]" data-id="element-169">{t.city}</span>
                </div>
              </div>
              <p className="text-brand-text text-[14px] italic leading-relaxed" data-id="element-170">
                "{t.quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}